<template>
  <div class="analysis">
    <!-- 5. 舆论活动分析 -->
    <titleTem :passTitleData="passTitleData"></titleTem>

    <!-- 搜索条件 -->
    <div class="condition_search">
      <el-row>
        <!-- 选择时间 :md="12" :lg="8"-->

        <div class="option time">
          <el-row>
            <el-col :md="24" v-if="!isMyDate">
              <div class="option region">
                <div class="item_title">Select Time:</div>
                <el-date-picker
                  @blur="getStartDate"
                  type="date"
                  placeholder="Start date"
                  v-model="startDate"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptionsStart"
                  size="large"
                ></el-date-picker>
                <span class="to_txt">&nbsp;&nbsp;to&nbsp;&nbsp;</span>
                <el-date-picker
                  @blur="getEndDate"
                  type="date"
                  placeholder="End date"
                  v-model="endDate"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptionsEnd"
                  size="large"
                ></el-date-picker>
              </div>
            </el-col>
            <el-col :md="24" :lg="19" v-else>
              <div class="option region">
                <div class="item_title">Select Time:</div>
                <DatePicker
                  :startTime="startDate"
                  :endTime="endDate"
                  @startConfirm="startConfirm"
                  @endConfirm="endConfirm"
                  @startCancel="startCancel"
                  @endCancel="endCancel"
                  @startClear="startClear"
                  @endClear="endClear"
                ></DatePicker>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </div>

    <div class="echarts_container">
      <ELine :echartsData="echartsData" :isNodata="isNodata"></ELine>
    </div>
  </div>
</template>

<script>
import titleTem from "./Title";
// import EBar from "../echarts/AnalysisBar";
// import EPie from "../echarts/AnalysisPie";
import ELine from "../echarts/AnalysisLine";
import {
  industryList,
  listofCountries,
  activePublic,
  activePublicPie,
  activePublicLine
} from "@/common/js/http/version3Api.js";
import DatePicker from "../mobile/DatePickerLocal";

export default {
  name: "Analysis",
  components: {
    titleTem,
    ELine,
    DatePicker
  },

  data() {
    return {
      isMyDate: false,
      isNodata: false,
      pickerOptionsStart: {
        disabledDate: time => {
          // let endDateVal = this.endDate;
          // if (endDateVal) {
          //   return time.getTime() > new Date(endDateVal).getTime();
          //   //return time.getTime() < new Date(endDateVal).getTime() - 30 * 24 * 60 * 60 * 1000 || time.getTime() > new Date(endDateVal).getTime();
          // }
          if (this.endDate === "" || this.endDate !== "") {
            let endDateVal = 1561910461 * 1000;
            if (endDateVal) {
              return (
                time.getTime() < 1561910461 * 1000 ||
                time.getTime() > new Date(this.endDate).getTime()
              );
            }
          } else {
            let endDateVal = this.endDate;
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          // let beginDateVal = this.startDate;
          // if (beginDateVal) {
          //   return time.getTime() < new Date(beginDateVal).getTime();
          //   //return time.getTime() > new Date(beginDateVal).getTime() + 30 * 24 * 60 * 60 * 1000 || time.getTime() < new Date(beginDateVal).getTime();
          // }
          if (this.startDate === "") {
            let beginDateVal = 1561910461 * 1000;
            if (beginDateVal) {
              return time.getTime() < 1561910461 * 1000;
            }
          } else {
            let beginDateVal = this.startDate;
            if (beginDateVal) {
              return time.getTime() < new Date(beginDateVal).getTime();
            }
          }
        }
      },
      passTitleData: {
        titleName: "Public Opinion Activation",
        commentTxt:
          "It refers to the trend analysis of overall overseas public opinions of a brand, through weighted calculation of the posts, likes, comments, emotion, and countries involved within a certain time frame (in past 30 days by default)."
      },

      //柱状图数据
      echartsData: [
        ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], //xAxis
        [
          {
            name: "Voice volume index", //yAxis
            data: [820, 932, 901, 934, 1290, 1330, 1320] //series
          }
        ]
      ],

      // 搜索条件
      startDate: "",
      endDate: "",
      clickState: false
    };
  },
  created() {
    //屏幕宽度
    if (document.documentElement.clientWidth < 768) this.isMyDate = true;
    else this.isMyDate = false;
    this.setDate();
  },
  mounted() {
    this.getActivityData();
  },
  methods: {
    setDate() {
      this.startDate = this.$moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    },
    //获取数据
    async getActivityData() {
      if (this.startDate == null || this.startDate == "Invalid date") {
        this.startDate = "";
      }
      if (this.endDate == null || this.endDate == "Invalid date") {
        this.endDate = "";
      }
      let data = {
        companyId: this.$route.query.id,
        endTime: this.endDate,
        startTime: this.startDate,
        brandToken: localStorage.getItem("brand-token")
      };
      const { result } = await activePublicLine(data);
      let firstArray = [],
        secondArray = [];
      let one = firstArray.push({
        name: result.yAxis.type,
        data: result.series[0].data
      });
      let two = secondArray.push(result.xAxis.data, firstArray);
      this.$set(this.echartsData, "lineData", secondArray);
      this.echartsData = this.echartsData.lineData;
      if (this.echartsData[0].length === 0) {
        this.isNodata = true;
      } else {
        this.isNodata = false;
      }
    },

    getStartDate() {
      this.getActivityData();
    },
    getEndDate() {
      this.getActivityData();
    },

    getContent(val) {},
    //移动端日期选择
    startConfirm(startTime) {
      this.startDate = this.$moment(new Date(startTime)).format("YYYY-MM-DD");
      this.getActivityData();
    },
    endConfirm(endTime) {
      this.endDate = this.$moment(new Date(endTime)).format("YYYY-MM-DD");
      this.getActivityData();
    },
    startCancel() {
      this.startDate = "";
      this.getActivityData();
    },
    endCancel() {
      this.endDate = "";
      this.getActivityData();
    },
    startClear() {
      this.startDate = "";
      this.getActivityData();
    },
    endClear() {
      this.endDate = "";
      this.getActivityData();
    }
  },
  watch: {
    startDate(newValue) {
      if (newValue == null) {
        this.getActivityData();
      }
    },
    endDate(newValue) {
      if (newValue == null) {
        this.getActivityData();
      }
    }
  }
};
</script>

<style scoped>
.echarts_container {
  /* display: inline-block; */
}
.time >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 125px !important;
}
.time >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.time .date_item {
  margin-right: 0 !important;
  line-height: 32px !important;
  width: 90% !important;
  text-align: right !important;
}
/* .bar_style {
  width: 60%;
}

.pie_style {
  width: 40%;
} */
</style>
